export const createData = (data) => {
    if (!data) return {
        labels: [],
        datasets: [{
            label: 'Total actions',
            data: [],
        }]
    };
    const labels = data.map(d => d.label);
    const values = data.map(d => d.value);

    return {
        labels,
        datasets: [{
            label: 'Total actions',
            data: values,
            borderWidth: 1,
            borderColor: '#1890A5',
            backgroundColor: '#1890A5'
        }]
    };
};

export const graphOptions = {
    scales: {
        y: {
            beginAtZero: true,
        }
    },
    plugins: {
        legend: false
    },
    layout: {
        padding: 20
    }
};
